import { Switch } from "@base-ui/react/switch";
import type { ComponentProps } from "react";

import { cn } from "../foundations/cn.js";
import { FOCUS_RING } from "../foundations/interaction.js";

export interface ToggleProps extends Omit<ComponentProps<typeof Switch.Root>, "className"> {
  /** The name. The switch shows no text: put the same words beside it, or use `children`. */
  label: string;
  className?: string;
}

/** An on/off setting that applies the moment it changes (`role="switch"`). */
export function Toggle({ label, className, ...props }: ToggleProps) {
  return (
    <Switch.Root
      aria-label={label}
      className={cn(
        "group inline-flex h-6 w-10 shrink-0 cursor-pointer items-center rounded-pill bg-bg-hover px-0.5",
        "data-checked:bg-accent-default data-checked:hover:bg-accent-hover data-disabled:cursor-default data-disabled:opacity-40",
        FOCUS_RING,
        className,
      )}
      {...props}
    >
      <Switch.Thumb className="size-5 rounded-pill bg-text-secondary transition-transform duration-fast ease-standard group-hover:bg-text-primary data-checked:translate-x-4 data-checked:bg-text-on-accent data-checked:group-hover:bg-text-on-accent motion-reduce:transition-none" />
    </Switch.Root>
  );
}
